import moment from "moment";

const store = {
  namespaced: true,
  state: {
    hash: null,
    accountId: null,
    accountStatus: null,
    planId: null,
    planType: null,
    vanityAccountType: null,
    totalAnnualElection: null,
    employeeAnnualElection: null,
    employerAnnualElection: null,
    actualBalance: null,
    availableBalance: null,
    rolloverBalanceRemaining: null,
    totalDisbursementsYtd: null,
    rolloverDepositsYtd: null,
    forfeitureBalance: null,
    deniedCardTransactionsYtd: null,
    totalDepositsYtd: null,
    employeeContribution: null,
    employeEDepositsYtd: null,
    employerContribution: null,
    employeRDepositsYtd: null,
    employeeOutOfPocket: null,
    coverageTier: null,
    isProrated: null,
    terminatedDate: null,
    createdDate: null,
    effectiveDate: null,
    firstPayroll: null,
    calendarId: null,
    hraConfig: null,
    isHra: null,
    isHsa: null,
    isCra: null,
    isPrefunded: null,
    cipStatus: null,
    cipApprovalDate: null,
    ready: false,
    terminationId: null
  },
  getters: {
    isNewAccount: (state) => {
      return !state.accountId;
    },
    requiresLifeEvent: (state, getters, rootState) => {
      let exemptAccountTypes = ["PKG", "PKP", "TRN", "TRP", "HSA"];
      let participantCreatedToday = !rootState.participant.createdDate || new moment(rootState.participant.createdDate).format("YYYY-MM-DD") == new moment().format("YYYY-MM-DD");
      let planStartDateInFuture = new moment(rootState.plan.startDate).format("YYYY-MM-DD") > new moment().format("YYYY-MM-DD");
      if (participantCreatedToday || planStartDateInFuture || rootState.session.user.isInternalUser) return false;
      else {
        return !Boolean(exemptAccountTypes.find(at => { return at === rootState.plan.planType }));
      }
    },
  },
  actions: {
    async load({state, commit}, data) {
        commit("setAccountsReady", false);
        let accs = this.state.accounts.accounts;
        let acc = findAccount(accs, data.accountId, data.planId);
        if (!acc) commit("reset");
        commit("setAccount", acc);
        commit("setAccountsReady", true);
    },
    async add({state, rootState}, data) {
        await romeApi.post(`/participant/${rootState.participant.participantId}/account`, data);
    },
    async update({state, rootState}, data) {
        await romeApi.post(`/participant/${rootState.participant.participantId}/account/${data.accountUpdate.accountId}`, data);
    },
  },
  mutations: {
    setAccount(state, account) {
      utils.copyCommonProperties(account, state);
      state.hash = new Date().getTime();
    },
    setAccountsReady(state, value) {
        state.ready = value;
    },
    reset(state) {
      Object.keys(state).forEach(key => {
        state[key] = null;
      })
    }
  }
};

function findAccount(accounts, accountId, planId){
  return _.find(accounts, function (a) {
    return accountId ? a.accountId === Number(accountId) : a.planId === Number(planId);
  });
}



export default store;



// WEBPACK FOOTER //
// ./src/accounts/x-account.js